import { EnglishArabicDTO } from "bnsights-control-library"
export class SendEmailTemplateModel
{
      TemplateID:number
      LangKey :string
      ToEmails :string
      EmailProviderName:string
      ErrorMessage:string
      IsSuccess:boolean


}